import { ObstetricalCounters } from "../MedicalSummary/ObstetricalSummary";

abstract class BaseObstetricalFileForm {
    public Context: ObstetricFormContext;
    public ObstetricalCounters: ObstetricalCounters;

    constructor(fields: Partial<BaseObstetricalFileForm>) {
        this.Context = new ObstetricFormContext(fields?.Context);
    }

    public stringify(): string {
        return JSON.stringify(this);
    }
}

class ObstetricFormContext {
    public PatientContactFacetId: string;
    public EncounterId: string;
    public ContributionId: string;

    constructor(fields?: Partial<ObstetricFormContext>) {
        Object.assign(this, fields);
    }
}

export { BaseObstetricalFileForm, ObstetricFormContext };
